import React, {Component} from 'react';
import FocusPageId from "../../FocusPageId";
import {Link} from "react-router-dom";

let i=0;
class QualityAssurance extends React.Component {
    componentDidMount() {
        // window.scrollTo(0, 0);
        let element = document.getElementById(FocusPageId.selectedId.elementId);
        element.scrollIntoView(true);
        element.classList.add('mystyle');
        // element.style.paddingTop="50px"
        window.scrollTo({
            top: document.getElementById(FocusPageId.selectedId.elementId).offsetTop - 40,
            behavior: 'smooth'
        });


    }
    constructor(props) {
        super(props);

        this.positionAdject=this.positionAdject.bind()
    };

    positionAdject = () => {
        i++;
        // if(i<3){
        //     document.getElementById(FocusPageId.selectedId.elementId).style.paddingTop="0px";

        // }

    };
    render() {

        return (
            <div className="static-pages" onWheel={() => this.positionAdject()}>
                <div className="background-div">
                    <li><h3 className="inline-block-element"><b>品質保証・返品について</b></h3></li>
                     <div className="brElement"></div>
                    <h4  id="a"><b> 保証はどうなりますか？</b>
                    </h4>
                    <p className='all-content-font-size'>不具合の原因が弊社の起因する場合、再制作に掛かる費用は弊社で負担いたします。
                    </p>
                    <p className='all-content-font-size'> 但し、ご注文いただいた利用金額の範囲内での保証とさせていただきます、ご了承ください。
                    </p>
                    <p className='all-content-font-size'> ※当サイトを使用して製造された商品を第三者へ転売した場合、その第三者への直接の保証およびサポートは行なっておりません。
                    </p>
                    <p className='all-content-font-size'> 第三者の方への直接の保証およびサポートは、第三者へ販売されたお客様にてお願いいたします。
                    </p>


                     <div className="brElement"></div>
                    <h4  id="b"><b> 保証期間はいつまでですか？</b>
                    </h4>
                    <p className='all-content-font-size'>初期不良に関する保証期間は、納品日より起算し30日間です。
                    </p>
                    <p className='all-content-font-size'> ※商品納入後速やかに行ってください、お客様のお手元で、確認作業までに経過した期間も保証期間内に含まれますのでご注意ください。
                    </p>

                     <div className="brElement"></div>
                    <h4  id="c"><b> どのような場合が保証対象外ですか？</b>
                    </h4>
                    <p className='all-content-font-size'>
                    </p>
                    <p className='all-content-font-size'> お客様のお取り扱い上の不注意や誤りによる故障や損傷
                    </p>
                    <p className='all-content-font-size'> お客様の設計や仕様に起因する不具合や故障
                    </p>
                    <p className='all-content-font-size'> お客様における修理、改造に起因する故障や損傷
                    </p>
                    <p className='all-content-font-size'> 異常電圧や指定外の電源の使用、定格ならびに推奨使用環境以外での使用による故障や損傷
                    </p>
                    <p className='all-content-font-size'> 車両、船舶、航空機等の制動装置の制御等、人命に関わる部分に利用された場合
                    </p>
                    <p className='all-content-font-size'> 軍事目的、原子力制御、医療機器等生命維持に関わる部分に利用された場合
                    </p>
                    <p className='all-content-font-size'> 天災、公害、火災等不慮の事故、その他外部要因による故障や損傷
                    </p>

                     <div className="brElement"></div>
                    <h4  id="d"><b> 返品したいのですが？</b>
                    </h4>
                    <p className='all-content-font-size'>受注ミスや出荷ミスなど弊社の過失によりお届けした商品が異なる場合には返品をお受け付けいたします。
                    </p>
                    <p className='all-content-font-size'> ※その際にはアカウントページ→注文履歴→品質報告窓口よりご連絡ください。
                    </p>

                     <div className="brElement"></div>
                    <h4  id="e"><b> どこに返品すればいいですか？</b>
                    </h4>
                    <p className='all-content-font-size'>アカウントページ→注文履歴→品質報告窓口よりご連絡ください。
                    </p>
                    <p className='all-content-font-size'> RIZEN HK LIMITED
                    </p>
                    <p className='all-content-font-size'> Unit 904, 9/F, Tern Plaza, 5 Cameron Road, Tsim Sha Tsui, Kowloon, Hong Kong
                    </p>
                    <p className='all-content-font-size'> TEL：+852 2369 8781
                    </p>
                    <p className='all-content-font-size'> KITCUT PCB department
                    </p>

                     <div className="brElement"></div>
                    <p id='f' className='all-content-font-size'><b> 返品送料の負担について教えて下さい。</b>
                    </p>
                    <p className='all-content-font-size'>弊社までの運送費はお客様ご負担にてお願いしております、ご了承ください。
                    </p>

                    <div className='col-md-10'></div>
                    <div className='col-md-2 col-12-custom'>
                        <Link to="/qualityassuranceTopic">
                            <span className='font-size-20'>
                            戻る
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}

export default QualityAssurance;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/FaqPages/QualityAssurance.js